import styled from 'styled-components';

export const ResizeHandle = styled.div<{ isResizing: boolean }>`
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  background: rgb(101, 103, 235);
  cursor: nwse-resize;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
  opacity: ${({ isResizing }) => (isResizing ? 1 : 0.8)};
  transition: opacity 0.2s ease-in-out;
  border-radius: 100%;

  &:hover {
    opacity: 1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
`;

export const ResizeIcon = styled.div`
  width: 100%;
  height: 100%;
`;
